export default __webpack_public_path__ + "static/media/bedroom1.329baff6.png";